<template>
  <div>
    <div class="mb-3">
      Op deze pagina kunnen de bedragen in de inspecties worden geindexeerd.
    </div>
    <b-row>
      <b-col 
        cols="3" 
        cols-sm="12"
      >
        <b-form-group>
          <b-input-group prepend="jaar">
            <b-input 
              v-model.number="jaar" 
              type="number" 
              @change="getInspecties"
            />
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-input-group prepend="index">
            <b-input 
              v-model.number="index" 
              type="number"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-table
      :caption="`De inspecties met als prijspeiljaar ${jaar}: ${inspecties.length} inspecties`"
      :items="inspecties"
      :fields="[
        { key: 'Unit', label: 'Unit' },
        { key: 'bouwjaar'},
        { key: 'relatie', label: 'Relatie' },
      ]"
      caption-top
      small
      select-mode="multi"
      hover
      bordered
      selectable
      @row-selected="selectRows"
      @row-clicked="
        (record, index) => (record._showDetails = !record._showDetails)
      "
    >
      <template #cell(Unit)="row">
        {{ row.item.kenmerk }}<br> {{ row.item.titel }}{{ row.item.adres }}
      </template>

      <template #row-details="row">
        <!--- tonen inspectie resultaat met indexering --->
        <PrognoseResultaat 
          :url="`/unit/${row.item.unit_id}/inspectie/${row.item.id}`"
          :bouwjaar="row.item.bouwjaar"
          :elementen="elementen"
          :index="index"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { elementenMixin } from "@/mixins/elementenMixin";
import PrognoseResultaat from '../../components/PrognoseResultaat.vue';
export default {
    name: "Indexering",
    components: { PrognoseResultaat },
    mixins: [ serviceMixin, elementenMixin ],
    data() {
        return {
            // TODO: 3 jaar terug ingesteld voor alle inspecties
            jaar: new Date().getFullYear() - 3, 
            inspecties: [],
            selectie: [],
            index: 1.054,
        };
    },
    mounted() {
        this.loadElementen();
        this.getInspecties();
    },
    methods: {
        selectRows(items) {
            this.selectie = items;
        },
        onRowClick(record, index) {
            console.log(index);
            record.toggleDetails;
        },
        getInspecties() {
            console.log("getInspecties");
            var vm = this;
            var url = `/inspecties/${this.jaar}/indexering`;
            this.get(url)
                .then((response) => {
                console.log(response.data);
                vm.inspecties = response.data.inspecties;
            })
                .catch(function (error) {
                console.log(error);
            })
                .finally(() => { });
        },
    },
};
</script>